'use client';

import { faPrint } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/ui/components/ui/button';

export function PrintButton() {
	return (
		<Button
			type="button"
			variant="outline"
			className="shadow-none h-[38px] border-gray-500 px-[6px] py-2 font-semibold min-w-16 gap-1"
			onClick={() => {
				window.print();
			}}
		>
			<FontAwesomeIcon icon={faPrint} />
			<p className="text-gray-600">Print</p>
		</Button>
	);
}
